import { type FC } from 'react';

import type { VerticalTicketItemType } from '@weberus/shared-types';
import { ImageComponentForThumbnail } from '@weberus/ui/components/image-component-for-thumbnail';
import { Thumbnail } from '@yanolja-rnd/nol-design-system';

import { getImage } from '../../utils/get-image';

export interface VerticalTicketItemProps extends VerticalTicketItemType {
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

/**
 * 놀티켓 랭킹형
 * @see {@link https://www.figma.com/design/TQk32C9K0kGCYGBCdksS8R/%ED%99%88-%EC%84%9C%EB%B8%8C%ED%99%88-%EB%9D%BC%EC%9D%B4%EB%B8%8C?node-id=1-267644&m=dev&focus-id=1-267644}
 */
export const VerticalTicketItem: FC<VerticalTicketItemProps> = (props) => {
  const { title, location, features, action, ranking, image, onClick } = props;

  const locationDisplay = !!location?.value && (
    <div className="mt-8 overflow-hidden typography-body-12-regular-line-clamp-2 pc:typography-subtitle-16-regular-line-clamp-2 text-text-neutral-sub pc:mt-2">
      {location.value}
    </div>
  );

  const dateDisplay = !!features[0].value && (
    <div className="mt-4 overflow-hidden typography-body-12-regular-line-clamp-2 text-text-neutral-medium pc:typography-subtitle-16-regular-line-clamp-2 pc:mt-2">
      {features[0].value}
    </div>
  );

  // 놀티켓 랭킹형
  return (
    <a href={action.web} onClick={(e) => onClick?.(e)}>
      {/* [랭킹형] 모바일 뷰 */}
      <div className="text-text-neutral-main w-[160px] pc:hidden">
        <Thumbnail
          alt=""
          className="relative mb-16"
          image={image.url}
          imageComponent={ImageComponentForThumbnail}
          ratio={{
            mobile: '3_4',
            pc: '3_4',
          }}
          shape={{
            mobile: 'roundedRectangle_8',
            pc: 'roundedRectangle_16',
          }}
        >
          {/* 그라데이션 - 썸네일 위에 표시 */}
          {/*<div className="absolute inset-0 w-full h-full rounded-lg border-[0.5px] border-[rgba(0,0,0,0.05)] bg-[linear-gradient(180deg,rgba(0,0,0,0.02)_0%,rgba(0,0,0,0.02)_59.95%,rgba(0,0,0,0.40)_89.93%,rgba(0,0,0,0.55)_99.92%)] z-10 pointer-events-none" />*/}
          <img
            alt=""
            className="absolute inset-0 w-full h-full rounded-lg"
            src={getImage(`/static/images/ranking/gradient.svg`)}
          />
          {/* 랭킹순위 - 그라데이션 위에 표시 */}
          <img
            alt={`랭킹 ${ranking.value}등`}
            className="absolute bottom-10 left-10 block pc:hidden z-10"
            src={getImage(`/static/images/ranking/rank${ranking.value.padStart(2, '0')}m.svg`)}
          />
        </Thumbnail>
        <div className="pc:px-4">
          <div className="overflow-hidden typography-body-14-regular-line-clamp-2">{title.value}</div>
          {locationDisplay}
          {dateDisplay}
        </div>
      </div>
      {/* [랭킹형] PC - slide 당 최대 10개 노출 */}
      <div className="text-text-neutral-main w-[240px] hidden pc:block">
        <Thumbnail
          alt=""
          className="relative mb-16"
          image={image.url}
          imageComponent={ImageComponentForThumbnail}
          ratio={{
            mobile: '3_4',
            pc: '3_4',
          }}
          shape={{
            mobile: 'roundedRectangle_8',
            pc: 'roundedRectangle_16',
          }}
        >
          {/* 그라데이션 - 썸네일 위에 표시 */}
          {/*<div className="absolute inset-0 w-full h-full rounded-lg border-[0.5px] border-[rgba(0,0,0,0.05)] bg-[linear-gradient(180deg,rgba(0,0,0,0.02)_0%,rgba(0,0,0,0.02)_59.95%,rgba(0,0,0,0.40)_89.93%,rgba(0,0,0,0.55)_99.92%)] z-10 pointer-events-none" />*/}
          <img
            alt=""
            className="absolute inset-0 w-full h-full rounded-lg"
            src={getImage(`/static/images/ranking/gradient.svg`)}
          />
          {/* 랭킹순위 - 그라데이션 위에 표시 */}

          <img
            alt={`랭킹 ${ranking.value}등`}
            className="absolute bottom-16 left-16 hidden pc:block z-10"
            src={getImage(`/static/images/ranking/rank${ranking.value.padStart(2, '0')}.svg`)}
          />
        </Thumbnail>
        <div>
          <div className="overflow-hidden typography-subtitle-18-regular-line-clamp-2">{title.value}</div>
          {locationDisplay}
          {dateDisplay}
        </div>
      </div>
    </a>
  );
};
